export const portfolioTypeOptions = [
  { label: "Capguard Fondskonto", value: "20" },
  { label: "Capguard VPS", value: "21" },
  { label: "Capguard ASK", value: "22" },
  { label: "Capguard IPS", value: "23" },
  { label: "Capguard Unotert", value: "24" },
  { label: "Nordnet ASK", value: "Nordnet ASK" },
  { label: "Nordnet IPA", value: "Nordnet IPA" },
  { label: "Nordnet IPS", value: "Nordnet IPS" },
  { label: "Nordnet Link", value: "Nordnet Link" },
  { label: "Nordnet PKB", value: "Nordnet PKB" },
  { label: "Nordnet VPS", value: "Nordnet VPS" },
];

/** Only these portfolio types are available for company (juridical) contacts. */
export const COMPANY_ALLOWED_PORT_TYPES = new Set(["20", "21", "Nordnet VPS"]);

const BASE_MANAGEMENT_FEES = [
  "0",
  "0.4",
  "0.5",
  "0.6",
  "0.7",
  "0.8",
  "0.9",
  "1.0",
  "1.1",
  "1.2",
];

type Option = { label: string; value: string };

export const ADVANCED_EKB_OPTIONS = [
  {
    value: "Cash",
    label:
      "Et beløp tilsvarende tegningsgarantibeløpet skal plasseres som kontanter på klientkonto.",
  },
  {
    value: "FixedIncomeFund",
    label:
      "Et beløp tilsvarende tegningsgarantibeløpet skal plasseres i et norsk rente/pengemarkedsfond, nærmere bestemt av forvalter.",
  },
  {
    value: "OrdinaryManagement",
    label:
      "Midlene i EKB-porteføljen skal forvaltes som vanlig, uavhengig av eventuell deltakelse i tegningsgaranti.",
  },
] as const;

export function getExistingAdvancedEKB(tags: readonly string[] = []) {
  return (
    ADVANCED_EKB_OPTIONS.find((option) =>
      tags.includes(`AdvancedEKB-${option.value}`)
    )?.value ?? ""
  );
}

export function getModelOptions(
  portType: string,
  classification2Code?: string
): Option[] {
  const options: Option[] = [{ label: "Manuell", value: "NOMODEL" }];

  if (portType === "22") {
    options.push({ label: "Capguard Aksjer", value: "CAPGUARDAKSJER" });
  } else if (portType === "21") {
    options.push({ label: "Capguard EKB", value: "CAPGUARDEKB" });
    options.push({ label: "Capguard Eiendom", value: "CAPGUARDEIENDOM" });
    if (
      classification2Code === "ProfBB" ||
      classification2Code === "ProfRABB"
    ) {
      options.push({ label: "Fondsobligasjoner", value: "FONDSOBLIGASJON" });
    }
  } else if (portType === "20" || portType === "23") {
    options.push({ label: "Capguard Trygg", value: "CAPGUARDTRYGG" });
    options.push({ label: "Capguard Renter", value: "CAPGUARDRENTER" });
    options.push({ label: "Capguard 25", value: "CAPGUARD25" });
    options.push({ label: "Capguard 45", value: "CAPGUARD45" });
    options.push({ label: "Capguard 60", value: "CAPGUARD60" });
    options.push({ label: "Capguard 75", value: "CAPGUARD75" });
    options.push({ label: "Capguard Aksjer", value: "CAPGUARDAKSJER" });
  } else if (portType === "Nordnet PKB") {
    options.push({ label: "Nordnet Renter", value: "NORDNETRENTER" });
    options.push({ label: "Nordnet 25", value: "NORDNET25" });
    options.push({ label: "Nordnet 45", value: "NORDNET45" });
    options.push({ label: "Nordnet 60", value: "NORDNET60" });
    options.push({ label: "Nordnet 75", value: "NORDNET75" });
    options.push({ label: "Nordnet Aksjer", value: "NORDNETAKSJER" });
  }

  return options;
}

export function getManagementFeeOptions(
  portfolioFeePercent?: number
): Option[] {
  const options: Option[] = BASE_MANAGEMENT_FEES.map((f) => ({
    label: f,
    value: f,
  }));

  options.push({ label: "Listepris", value: "1.5" });

  if (portfolioFeePercent !== undefined) {
    const feeStr = String(portfolioFeePercent);
    const exists = options.some((v) => v.value === feeStr);
    if (!exists) {
      options.push({ label: feeStr, value: feeStr });
    }
  }

  options.sort((a, b) => {
    if (a.label === "Listepris") return 1;
    if (b.label === "Listepris") return -1;
    return parseFloat(a.value) - parseFloat(b.value);
  });

  return options;
}

export const CAPGUARD_PORT_TYPES = ["20", "21", "22", "23", "24"];

export const SERVICE_TYPE_LABELS: Record<string, string> = {
  orderExecution: "Ordreformidling",
  investmentAdvice: "Investeringsrådgivning",
};
